import { IconProps } from 'src/utils/icon';

const CopyIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    fill="none"
    viewBox="0 0 13 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.28571 13.125V14.2969C9.28571 14.6852 8.97392 15 8.58929 15H0.696429C0.311797 15 0 14.6852 0 14.2969V3.51562C0 3.1273 0.311797 2.8125 0.696429 2.8125H2.78571V11.4844C2.78571 12.389 3.51467 13.125 4.41071 13.125H9.28571ZM9.28571 3.04688V0H4.41071C4.02608 0 3.71429 0.314795 3.71429 0.703125V11.4844C3.71429 11.8727 4.02608 12.1875 4.41071 12.1875H12.3036C12.6882 12.1875 13 11.8727 13 11.4844V3.75H9.98214C9.59911 3.75 9.28571 3.43359 9.28571 3.04688ZM12.796 2.13782L10.8825 0.205928C10.7519 0.0740749 10.5748 9.74989e-07 10.3901 0L10.2143 0V2.8125H13V2.63499C13 2.44852 12.9266 2.26968 12.796 2.13782Z"
      fill={fill}
    />
  </svg>
);

export default CopyIcon;
